import Logo from "../../../assets/img/NewsImgs/newLogo.webp";
import React, { useState, useEffect } from "react";
import { axiosReq } from "../../../commons/axiosReq";
import parse from 'html-react-parser';

const AboutDetail = () => {
  const [contextData, setContextData] = useState();
  const GetData = async () => {

    const contexData = await axiosReq("Admins/GetContext", "get");
    console.log(999)
    console.log(contexData)
    setContextData(contexData[0]?.aboutUs)


  }

  useEffect(() => {

    GetData();
  }, []);
  return (
    <>
      <div className="w-[80%] mx-auto block bg-white shadow-white-shadow rounded-2xl p-[30px] -mt-96" >
        <div className="flex justify-center">
          <img src={Logo} className="w-[130px]" />
        </div>
        <div className="mt-10">
          <p className="font-IRANYekanMedium text-base text-black leading-8">
            {contextData? parse(contextData):null}
          </p>
        </div>
      </div>
    </>
  )
}

export default AboutDetail;